/*
 * @Author: 赵泽文
 * @Date: 2022-05-09 15:48:33
 * @LastEditors: 彭鑫诚
 * @LastEditTime: 2024-07-18 15:22:34
 * @Description: 采购订单数据存储
 */
import type {
  IPurchaseOrderModel,
  IPurchaseOrderStore,
} from '@monorepo/types/purchasing/purchaseOrder/purchaseOrder.types';
import { getToday } from '@monorepo/utils';
import { tableUpdate } from '@monorepo/utils';

const initState: IPurchaseOrderStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    date_type: 'CREATED_DATE',
    sort_order: 'CREATED_DESC',
    date: getToday(),
  },
  auditNo: '',
  total_money: '0',
  total_use_unit_qty: '0',
};

const purchaseOrderStore: IPurchaseOrderModel = {
  namespace: 'purchaseOrderStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default purchaseOrderStore;
